import React from 'react';
import Chip from '@material-ui/core/Chip';

const RegionField = ({ record, source }) => {
  const type = record[source];
  return <Chip key={type} label={type} style={{ fontSize: '11px' }} />;
};
RegionField.defaultProps = { label: 'Region', source: 'region' };

export default RegionField;
